/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { animated, useSpring } from '@react-spring/web'
import '../../../../assets/fonts/styles.css'
import validator from 'validator'
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import Logo from 'assets/images/quizedulogo.png'
import CardsLandingPage from 'assets/images/cardsLandingPage.png'
import CardsColorLandingPage from 'assets/images/cardsColorLandingPage.png'
import { useEffect, useRef, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React TS examples components
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import PageLayout from "examples/LayoutContainers/PageLayout";

// Material Dashboard 2 PRO React page layout routes
// import pageRoutes from "page.routes";

// Material Dashboard 2 PRO React context
import { Box, Card, Fade, Icon, IconButton, List, ListItemButton, ListItemIcon, ListItemText, Modal, Rating, Typography, useMediaQuery } from '@mui/material';
import { getTotalNumberOfQuizzes } from 'services/quiz-services';
import { Hexagon, HexGrid, Layout, Pattern, Text } from 'react-hexgrid';
import VideosSection from './VideoPlayer';
import { Slider } from './Slider';
import MDInput from 'components/MDInput';
import MDButton from 'components/MDButton';
import { Link, useNavigate } from 'react-router-dom';
import Loader from 'components/Loader';
import { subscribeNewsLetter } from 'services/sendpulse-service';
import testimonial1 from '../../../../assets/images/Line Honbæk.png'
import { useAppContext } from 'context/app-context';

function Number({n}: {n: number}) {
  const { number } = useSpring({
    from: { number: 0 },
    number: n,
    delay: 200,
    config: { mass: 1, tension:20, friction: 10 } },
  )
  return <animated.span>{number.to(n => n.toFixed(0))}</animated.span>
}

function IllustrationLayout(): JSX.Element {
  const { handleMessage } = useAppContext()

  const [loading, setLoading] = useState(true)
  const [hasClickedOnCreateAccount, setHasClickedOnCreateAccount] = useState(false)
  const [email, setEmail] = useState('')
  const [emailBottom, setEmailBottom] = useState('')
  const [totalNumberOfQuizzes, setTotalNumberOfQuizzes] = useState(0)
  const [displayPopUp, setDisplayPopUp] = useState(false);

  const closePopUp = () => {
    localStorage.setItem("seenPopUp", String(true));
    setDisplayPopUp(false);
  };

  useEffect(() => {
    if (loading) return;
    let returningUser = localStorage.getItem("seenPopUp") === 'true';
    const animationTimeout = setTimeout(() => {
      setDisplayPopUp(!returningUser);
    }, 1000);

    return () => clearTimeout(animationTimeout);
    
  }, [loading]);

  useEffect(() => {
    (async () => {
      setTotalNumberOfQuizzes(await getTotalNumberOfQuizzes())
      const timer = setTimeout(() => {
        setLoading(false)
      }, 3200);
      return () => clearTimeout(timer);
    })()
  }, [])

  const sliderRef = useRef<HTMLDivElement>(null);

  const handleSlide = (direction: string): void => {
    if (!sliderRef.current) {
      return;
    }
    if (direction === 'left') {
      sliderRef.current.scrollLeft -= 200;
    }
    else {
      sliderRef.current.scrollLeft += 200;
    }
  };

  async function handleSubscrtibe(email: string): Promise<void> {
    if (!email || !validator.isEmail(email)) {
      return handleMessage('Du skal skrive en email', 'error')
    }

    await subscribeNewsLetter(email)
    handleMessage('Tak for din tilmelding!', 'success')
    setEmail('')
    setEmailBottom('')
  }

  const isBigScreen = useMediaQuery('(min-width:1280px)')
  const isMediumScreen = useMediaQuery('(max-width:600px)')
  const isMobile = useMediaQuery('(max-width:499px)')

  const navigate = useNavigate()

  return (
    loading ? <Loader /> :
      <PageLayout background="#dff5fd">
        <DefaultNavbar
          routes={[]}
          action={{
            type: "internal",
            route: "/authentication/sign-up",
            label: "Få skoleadgang i dag",
            clickButton: () => navigate('/pris'),
            color: "error",
          }}
        />{displayPopUp && (
          <Modal
            open={true}
            onClose={closePopUp}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
          <Fade in={true} style={{
            transitionDelay: '1000ms'
          }}>
            <MDBox
              display='flex'
              flexDirection='column'
              justifyContent='center'
              alignItems='center'
              height='fit-content'
              mx='auto'
              p={8}
              position='absolute'
              top='50%'
              left='50%'
              sx={{
                transform: 'translate(-50%, -50%)',
                backgroundColor: '#f4feff',
                outline: 'none',
              }}
              maxWidth={'85vw'}
            >
              <MDTypography fontWeight='regular' variant="h1" textAlign='center' maxWidth={850} width='75vw'>
                Få mest ud fra QuizEdu: få seneste nyt
              </MDTypography>
              <MDTypography variant="p" minWidth={isMobile ? 'calc(100vw - 64px)' : { sm: 400 }} maxWidth={800} textAlign='center' width='75vw'>
                Værktøjer er bedst når de bliver brugt: så få tips og tricks, og inspiration direkte i indbakken.
              </MDTypography>
              <form onSubmit={(e) => {
                e.preventDefault()
                handleSubscrtibe(email)
                closePopUp()
                }}>
              <MDBox
                sx={{
                  width: '75vw',
                  maxWidth: 500
                }}
                display='flex'
                marginTop={4}
                marginBottom={1}
                gap={2}
              >
                <MDInput
                  required
                  fullWidth
                  label="Email"
                  placeholder='Skriv din mailadresse her'
                  style={{
                    backgroundColor: 'white',
                    borderRadius: 45
                  }}
                  sx={{
                    borderRadius: 45,
                    '& fieldset': {
                      borderRadius: 45,
                    },
                  }}
                  type='email'
                  value={email}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
                />
                <MDButton
                  sx={{
                    borderRadius: 45,
                  }}
                  type='submit'
                  color='error'
                >Tilmeld</MDButton>
                </MDBox>
                </form>
                <IconButton
                sx={{
                  backgroundColor: '#dff5fd',
                  '&:hover': {
                    backgroundColor: '#ffffff'
                  }
                }}
                style={{
                  position: 'absolute',
                  top: '-35px',
                  right: '-35px',
                  margin: 16,
                  color: '#7b809a'
                }}
                onClick={closePopUp}
              >
                <Icon fontSize='large'>close</Icon>
              </IconButton>
              </MDBox>
              </Fade>
          </Modal>
  )
}
{
  hasClickedOnCreateAccount ?
    <MDBox
      display='flex'
      width='100vw'
      height='100vh'
      pt={20}
    >
      <MDBox
        display='flex'
        flexDirection='column'
        gap={5}
        mx='auto'
        px={4}
        width={665}
        height='fit-content'
        paddingBottom='2em'
      >
        <Typography fontWeight={700} fontSize='1.2em' component='p'>Hejsa med dig :)</Typography>
        <Typography fontWeight={700} fontSize='1.2em' component='p'>Du vil gerne have adgang til QuizEdu? FEDT!</Typography>
        <Typography fontWeight={700} fontSize='1.2em' component='p'>QuizEdu abner først i august 2023; MEN din skole skal faktisk få tidlig adgang OG spare penge!</Typography>
        <Typography fontWeight={700} fontSize='1.2em' component='p'>Når jeres skole køber adgang på denne side af august, får I halv pris (kun 600kr ex moms for 1 år, 365 dage) <br /><MDTypography sx={{ fontWeight: 700 }} fontSize='1.2em' component='span' color='success'>PLUS</MDTypography> I får også en Quiz-pakke med i prisen (klik her for at se pakke)</Typography>
        <Typography fontWeight={700} fontSize='1.2em' component='p'>Det eneste du skal gøre for at få dette tilbud er; at skrive til mig: <a style={{ color: '#0563c1' }} href='mailto:jesperalbinus@quizedu.dk?subject=abonnement%20QuizEdu.dk&body=Hej,%20jeg%20er%20interesseret%20i%20at%20abonnere%20på%20QuizEdu.dk'>jesperalbinus@quizedu.dk</a></Typography>
        <Typography fontWeight={700} fontSize='1.2em' component='p'>Glæder mig til at du bliver en del af QuizEdu-familien 😀</Typography>
        <Typography fontWeight={700} fontSize='1.2em' component='p'>Med venlig hilsen</Typography>
        <Typography fontWeight={700} fontSize='1.2em' component='p'>Jesper Albinus, ejer af QuizEdu</Typography>
      </MDBox>
    </MDBox> :
    <MDBox
      // marginX='auto'
      height="100%"
      paddingTop={isMobile ? 15 : 10}
      overflow='hidden'
    >
      <Grid
        container
        mx='auto'
        height='fit-content'
      >
        <MDBox
          display='flex'
          gap={2}
          alignItems='end'
          height={200}
          width='100vw'
          justifyContent='center'
        >
          <MDTypography color="error" variant='h1' mt={4} textAlign='center'>Antal quiz-spørgsmål lige nu:{' '}
            <Number n={totalNumberOfQuizzes} />
            {/* <AnimatedNumber
                    component="span"
                    value={totalNumberOfQuizzes}
                    stepPrecision={0}
                    style={{
                      color: '#F44335',
                      transition: '0.8s ease-out',
                      // fontSize: '1.875rem',
                      lineHeight: 1.375,
                      fontWeight: 700
                    }}
                    duration={1000}
                    formatValue={(n: number) => n} /> */}
          </MDTypography>
        </MDBox>
        {/* <MDBox
              display='flex'
              flexDirection='column'
              justifyContent='end'
              height='fit-content'
            > */}
        <Grid item xs={12} lg={5}>
          <MDBox
            display='flex'
            flexDirection='column'
            alignItems={isBigScreen ? 'end' : 'center'}
            justifyContent='center'
            width={isBigScreen ? '100%' : '90vw'}
          >
            <MDBox display='flex' justifyContent='center' height={isBigScreen ? 700 : '100%'} flexDirection='column' paddingX={isBigScreen ? 0 : 4} width={isBigScreen ? 400 : '90vw'}>
              <MDTypography style={{ fontFamily: 'Asap' }} variant='h1'><span className='text-purple'>Sjovere</span> undervisning <br /> med <span className='text-blue'>faglige</span> Quizkort<span className='text-green'>!</span></MDTypography>
              <MDTypography variant="p">
                Brug QuizEdu's 1000vis af quizspørgsmål til at sætte gang i både træning og kreativitet imens hele klassen hygger sig.
                Tanken er: at vi har spørgsmålene og at dine elever udvikler idéerne til at lave egne brætspil evt. ved at bruge vores <u>brætspilspakke</u>. Opret dig allerede i dag og prøv vores Quizværktøj helt gratis!
              </MDTypography>
              <MDBox
                display='flex'
                marginTop={4}
                marginBottom={1}
                gap={2}
                width={isMobile ? 'calc(100vw - 64px)' : 400}
                maxWidth={400}
              >
                <MDInput
                  label="Email"
                  placeholder='Skriv din email her'
                  style={{
                    backgroundColor: 'white',
                    borderRadius: 45
                  }}
                  sx={{
                    borderRadius: 45,
                    '& fieldset': {
                      borderRadius: 45,
                    },
                  }}
                  type='email'
                />
                <MDButton
                  sx={{
                    borderRadius: 45,
                    whiteSpace: 'nowrap'
                  }}
                  color='error'
                  onClick={() => () => navigate('/pris')}
                >Få skoleadgang i dag</MDButton>
              </MDBox>

              <MDBox
                display='flex'
              >
                <img style={{
                  borderRadius: '50%',
                  width: 80,
                  height: 80,
                  border: '2px solid red',
                  marginRight: 4
                }} src={testimonial1} alt="name" />
                <MDBox
                  display='flex'
                  flexDirection='column'
                  justifyContent='center'
                >
                  <Rating value={5} readOnly />
                  <Typography>"Det er virkelig smart"</Typography>
                </MDBox>
              </MDBox>
            </MDBox>
          </MDBox>
        </Grid>
        <Grid item xs={12} lg={7}>
          <MDBox
            display='flex'
            flexDirection='column'
            alignItems={isBigScreen ? 'end' : 'center'}
            maxWidth={isBigScreen ? 700 : '100vw'}
          >
            <img src={CardsLandingPage} style={{
              objectFit: 'cover',
              objectPosition: '80% 100%',
              maxWidth: 700,
              width: '100%'
            }}
              alt='cards landing page illustration' />
          </MDBox>
        </Grid>
        {/* </MDBox> */}


        <Grid item xs={12} lg={6} sx={{ background: `#f4feff` }}>
          <MDBox
            overflow='visible'
            display='flex'
            flexDirection='column'
            alignItems={isBigScreen ? 'end' : 'center'}
            justifyContent='end'
            height='fit-content'
          >
            <img src={CardsColorLandingPage} style={{
              objectFit: 'cover',
              objectPosition: '80% 100%',
              maxWidth: 550,
              width: isBigScreen ? '100%' : '100%',
              // height: '100%'
            }} alt='cards landing page illustration' /></MDBox>
        </Grid>
        <Grid item xs={12} lg={4} sx={{ background: `#f4feff` }}>
          <MDBox
            display='flex'
            flexDirection='column'
            justifyContent='end'
            height='fit-content'
            width='100vw'
            sx={{
              background: `#f4feff`
            }}
          >
            <MDBox
              display='flex'
              flexDirection='column'
              justifyContent='center'
              height={isBigScreen ? 400 : '100%'}
              width={isBigScreen ? 600 : '100vw'}
              paddingX={4}
            >
              {/* <MDTypography style={{ color: '#5bb3e4' }} variant='p'>Tagline
                </MDTypography> */}
              <MDTypography variant="h2">
                Lav dine helt egne kategorier og spørgsmål eller brug vores quiz-bibliotek
              </MDTypography>
              <MDTypography variant="p">
                Aldrig har det været lettere at sammensætte en quiz. Og du bestemmer helt selv hvordan du sammensætter spørgsmålene. Du trækker blot kategorierne over på et digitalt kort som du lynhurtigt kan dele med dine elever via en QR-kode; og vupti: så har de alle spørgsmålene på deres telefon eller iPad.
              </MDTypography>
            </MDBox>
          </MDBox>
        </Grid>

      </Grid>

      <MDBox
        display='flex'
        flexDirection='column'
        justifyContent='end'
        marginX='auto'
        marginBottom={-25}
        sx={{
          backgroundColor: '#f4feff'
        }}
      >
        <HexGrid width={7500} height={450} viewBox="-50 -50 100 100">
          <Layout size={{ x: 15, y: 15 }} flat={true} spacing={1.1} origin={{ x: 0, y: 0 }}>
            <Hexagon q={-34} r={16} s={2} fill="pat-5" />
            <Hexagon q={-33} r={16} s={2} fill="pat-6" />
            <Hexagon q={-32} r={15} s={2} fill="pat-1" />
            <Hexagon q={-31} r={15} s={2} fill="pat-2" />
            <Hexagon q={-30} r={14} s={2} fill="pat-3" />
            <Hexagon q={-29} r={14} s={2} fill="pat-4" />
            <Hexagon q={-28} r={13} s={2} fill="pat-5" />
            <Hexagon q={-27} r={13} s={2} fill="pat-6" />
            <Hexagon q={-26} r={12} s={2} fill="pat-1" />
            <Hexagon q={-25} r={12} s={2} fill="pat-2" />
            <Hexagon q={-24} r={11} s={2} fill="pat-3" />
            <Hexagon q={-23} r={11} s={2} fill="pat-4" />
            <Hexagon q={-22} r={10} s={2} fill="pat-5" />
            <Hexagon q={-21} r={10} s={2} fill="pat-6" />
            <Hexagon q={-20} r={9} s={2} fill="pat-1" />
            <Hexagon q={-19} r={9} s={2} fill="pat-2" />
            <Hexagon q={-18} r={8} s={2} fill="pat-3" />
            <Hexagon q={-17} r={8} s={2} fill="pat-4" />
            <Hexagon q={-16} r={7} s={2} fill="pat-5" />
            <Hexagon q={-15} r={7} s={2} fill="pat-6" />
            <Hexagon q={-14} r={6} s={2} fill="pat-3" />
            <Hexagon q={-13} r={6} s={2} fill="pat-2" />
            <Hexagon q={-12} r={5} s={2} fill="pat-1" />
            <Hexagon q={-11} r={5} s={2} fill="pat-4" />
            <Hexagon q={-10} r={4} s={1} fill="pat-5" />
            <Hexagon q={-9} r={4} s={1} fill="pat-6" />
            <Hexagon q={-8} r={3} s={1} fill="pat-1" />
            <Hexagon q={-7} r={3} s={1} fill="pat-2" />
            <Hexagon q={-6} r={2} s={1} fill="pat-3" />
            <Hexagon q={-5} r={2} s={1} fill="pat-4" />
            <Hexagon q={-4} r={1} s={1} fill="pat-5" />
            <Hexagon q={-3} r={1} s={1} fill="pat-6" />
            <Hexagon q={-2} r={0} s={1} fill="pat-1" />
            <Hexagon q={-1} r={0} s={1} fill="pat-2" />
            <Hexagon q={0} r={-1} s={1} fill="pat-3" />
            <Hexagon q={1} r={-1} s={0} fill="pat-4" />
            <Hexagon q={2} r={-2} s={0} fill="pat-5" />
            <Hexagon q={3} r={-2} s={0} fill="pat-6" />
            <Hexagon q={4} r={-3} s={0} fill="pat-1" />
            <Hexagon q={5} r={-3} s={0} fill="pat-2" />
            <Hexagon q={6} r={-4} s={0} fill="pat-3" />
            <Hexagon q={7} r={-4} s={0} fill="pat-4" />
            <Hexagon q={8} r={-5} s={0} fill="pat-5" />
            <Hexagon q={9} r={-5} s={0} fill="pat-6" />
            <Hexagon q={10} r={-6} s={0} fill="pat-1" />
            <Hexagon q={11} r={-6} s={0} fill="pat-2" />
            <Hexagon q={12} r={-7} s={0} fill="pat-3" />
            <Hexagon q={13} r={-7} s={0} fill="pat-4" />
            <Hexagon q={14} r={-8} s={0} fill="pat-5" />
            <Hexagon q={15} r={-8} s={0} fill="pat-6" />
            <Hexagon q={16} r={-9} s={0} fill="pat-1" />
            <Hexagon q={17} r={-9} s={0} fill="pat-2" />
            <Hexagon q={18} r={-10} s={0} fill="pat-3" />
            <Hexagon q={19} r={-10} s={0} fill="pat-4" />
            <Hexagon q={20} r={-11} s={0} fill="pat-5" />
            <Hexagon q={21} r={-11} s={0} fill="pat-6" />
            <Hexagon q={22} r={-12} s={0} fill="pat-1" />
            <Hexagon q={23} r={-12} s={0} fill="pat-2" />
            <Hexagon q={24} r={-13} s={0} fill="pat-3" />
            <Hexagon q={25} r={-13} s={0} fill="pat-4" />
            <Hexagon q={26} r={-14} s={0} fill="pat-5" />
            <Hexagon q={27} r={-14} s={0} fill="pat-6" />
            <Hexagon q={28} r={-15} s={0} fill="pat-1" />
            <Hexagon q={29} r={-15} s={0} fill="pat-2" />
            <Hexagon q={30} r={-16} s={0} fill="pat-3" />
            <Hexagon q={31} r={-16} s={0} fill="pat-4" />
            <Hexagon q={32} r={-17} s={0} fill="pat-5" />
            <Hexagon q={33} r={-17} s={0} fill="pat-6" />
            <Hexagon q={34} r={-18} s={0} fill="pat-1" />
            <Hexagon q={35} r={-18} s={0} fill="pat-2" />
            <Pattern id="pat-1" link="https://quizcards-docs-dev.s3.eu-west-1.amazonaws.com/site-documents/Sp%C3%B8rgsma%CC%8AlNY2.png-1.png" size={{ x: 15, y: 13 }} />
            <Pattern id="pat-2" link="https://quizcards-docs-dev.s3.eu-west-1.amazonaws.com/site-documents/Sp%C3%B8rgsma%CC%8AlNY2.png-2.png" size={{ x: 15, y: 13 }} />
            <Pattern id="pat-3" link="https://quizcards-docs-dev.s3.eu-west-1.amazonaws.com/site-documents/Sp%C3%B8rgsma%CC%8AlNY2.png-3.png" size={{ x: 15, y: 13 }} />
            <Pattern id="pat-4" link="https://quizcards-docs-dev.s3.eu-west-1.amazonaws.com/site-documents/Sp%C3%B8rgsma%CC%8AlNY2.png-4.png" size={{ x: 15, y: 13 }} />
            <Pattern id="pat-5" link="https://quizcards-docs-dev.s3.eu-west-1.amazonaws.com/site-documents/Sp%C3%B8rgsma%CC%8AlNY2.png-5.png" size={{ x: 15, y: 13 }} />
            <Pattern id="pat-6" link="https://quizcards-docs-dev.s3.eu-west-1.amazonaws.com/site-documents/Sp%C3%B8rgsma%CC%8AlNY2.png-6.png" size={{ x: 15, y: 13 }} />
          </Layout>
        </HexGrid>

        {/* <img src={subjectsHexagonsLandingPage} alt="subjects hexagons" style={{objectFit: 'cover',
                objectPosition: '100% 0'}} /> */}
      </MDBox>
      <MDBox
        sx={{ background: `#f4feff` }}
        paddingY={10}
        display='flex'
        flexDirection='column'
        alignItems='center'
      >
        <MDBox
          display='flex'
          flexDirection='row'
          justifyContent='space-between'
          alignItems='center'
          width='100vw'
          maxWidth={1272}
          sx={{ background: `#f4feff` }}
          px={4}
        >
          <Grid container>
            <Grid item xs={12} lg={9}>
              <MDTypography style={{ color: '#5bb3e4' }} variant='p'>Tagline
              </MDTypography>
              <MDTypography variant="h2" sx={{ width: isBigScreen ? '100%' : '90vw' }}>
                Se hvordan QuizEdu kan bruges i din undervisning
              </MDTypography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <MDBox
                display={'flex'}
                justifyContent={isBigScreen ? 'end' : 'start'}
                alignItems='center'
                width={isBigScreen ? '100%' : '90vw'}
                height='100%'
                gap={1}
              >
                <IconButton style={{ border: '4px solid #7b809a' }} onClick={() => handleSlide('left')}><Icon fontSize='large'>arrow_back</Icon></IconButton>
                <IconButton style={{ border: '4px solid #7b809a' }} onClick={() => handleSlide('right')}><Icon fontSize='large'>arrow_forward</Icon></IconButton>
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
        <MDBox ref={sliderRef}
          px={4}
          overflow='hidden'
          style={{
            whiteSpace: 'nowrap',
            backgroundColor: '#f4feff',
            boxSizing: 'border-box',
            display: 'flex',
            width: '100vw',
            maxWidth: 1272,
            marginLeft: 'auto',
            marginRight: 'auto'
          }} >
          <VideosSection />
        </MDBox>
      </MDBox>
      <Box
        width='100vw'
        sx={{
          backgroundColor: '#f4feff'
        }}
      >
      <Box
        display='flex'
        alignItems='center'
        justifyContent='center'
        height='700px'
        width={isMobile ? 420 : isMediumScreen ? '100vw' : 600 }
        marginX='auto'
        sx={{
          backgroundColor: '#f4feff'
        }}
        position='relative'
      >
        <Slider />
      </Box>
      </Box>
      <MDBox

        height={700}
        width='100%'
        sx={{
          backgroundColor: '#dff5fd'
        }}
      >
        <MDBox
          display='flex'
          flexDirection='column'
          justifyContent='center'
          alignItems='center'
          height={700}
          width='fit-content'
          mx='auto'
        >
          <MDTypography fontWeight='regular' variant="h1" textAlign='center' maxWidth={850} width='90vw'>
            Få mest ud fra QuizEdu: få seneste nyt
          </MDTypography>
          <MDTypography variant="p" minWidth={isMobile ? 'calc(100vw - 64px)' : { sm: 400 }} maxWidth={800} textAlign='center' width='90vw'>
            Værktøjer er bedst når de bliver brugt: så få tips og tricks, og inspiration direkte i indbakken.
          </MDTypography>
          <MDBox
            display='flex'
            marginTop={4}
            marginBottom={1}
            gap={2}
            width={isMobile ? 'calc(100vw - 64px)' : 400}
            maxWidth={400}
          >
            <MDInput
              label="Email"
              placeholder='Skriv din mailadresse her'
              style={{
                backgroundColor: 'white',
                width: 300,
                borderRadius: 45
              }}
              sx={{
                borderRadius: 45,
                '& fieldset': {
                  borderRadius: 45,
                },
              }}
              type='email'
              value={email}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
            />
            <MDButton
              sx={{
                borderRadius: 45,
              }}
              color='error'
              onClick={() => handleSubscrtibe(email)}
            >Tilmeld</MDButton>
          </MDBox>
        </MDBox>
      </MDBox>

      <MDBox
        height={700}
        width='100vw'
        sx={{
          backgroundColor: '#f4feff'
        }}
      >
        <MDBox
          display='flex'
          flexDirection='column'
          justifyContent='center'
          alignItems='center'
          height={900}
          width='fit-content'
          mx='auto'
        >
          <Card
            sx={{
              marginX: 0,
              paddingX: '3.6rem',
              paddingY: '1.5rem',
              border: '5px solid #84c3e1',
              width: 'fit-content',
              minWidth: isMobile ? 350 : 450,
              height: 'fit-content'
            }}
          >
            <Typography
              sx={{
                color: '#005f8f'
              }}
              variant='h3'
            >
              Kontakt os
            </Typography>
            <MDTypography sx={{ fontSize: 14 }}>Vi svarer altid samme dag</MDTypography>
            <MDInput
              fullWidth
              label="Navn"
              style={{
                marginTop: '2rem',
                backgroundColor: 'white',
                borderRadius: 45
              }}
              sx={{
                borderRadius: 45,
                '& fieldset': {
                  borderRadius: 45,
                },
              }}
              type='text'
            />
            <MDInput
              fullWidth
              label="E-mail"
              style={{
                marginTop: '1rem',
                backgroundColor: 'white',
                borderRadius: 45
              }}
              sx={{
                borderRadius: 45,
                '& fieldset': {
                  borderRadius: 45,
                },
              }}
              type='email'
            />
            <MDInput
              multiline
              rows={4}
              fullWidth
              label="Din besked..."
              style={{
                marginTop: '1rem',
                backgroundColor: 'white',
                borderRadius: 5
              }}
              sx={{
                borderRadius: 5,
                '& fieldset': {
                  borderRadius: 5,
                },
              }}
              type='text'
            />
            <MDButton sx={{ marginTop: '2rem', borderRadius: 45 }} color='error'>Send besked</MDButton>
          </Card>
        </MDBox>
      </MDBox>
      <MDBox
        width={'100vw'}
        height='fit-content'
        sx={{
          backgroundColor: '#f4feff'
        }}
        py={isBigScreen ? 10 : 0}
        paddingTop={isBigScreen ? 'inherit' : 10}
      >
        <MDBox
          width='fit-content'
          marginX='auto'
          marginBottom={isBigScreen ? -30 : "-15%"}
        >
          <HexGrid style={{
            objectFit: 'none',
            objectPosition: '50% 50%',
            maxWidth: 1200,
            width: '100vw',
            height: '100%'
          }} width={1200} height={500} viewBox="-50 -50 100 100">
            <Layout size={{ x: 18, y: 18 }} flat={true} spacing={1.1} origin={{ x: 0, y: 0 }}>
              <Hexagon q={-3} r={1} s={1} fill="blue"><Text fill='#ffffff'>?</Text></Hexagon>
              <Hexagon q={-2} r={0} s={1} fill="red"><Text fill='#ffffff'>?</Text></Hexagon>
              <Hexagon q={-1} r={0} s={1} fill="yellow"><Text fill='#ffffff'>?</Text></Hexagon>
              <Hexagon q={0} r={-1} s={1} fill="purple"><Text fill='#ffffff'>?</Text></Hexagon>
              <Hexagon q={1} r={-1} s={0} fill="green"><Text fill='#ffffff'>?</Text></Hexagon>
              <Hexagon q={2} r={-2} s={0} fill="orange"><Text fill='#ffffff'>?</Text></Hexagon>
              <Hexagon q={3} r={-2} s={0} fill="blue"><Text fill='#ffffff'>?</Text></Hexagon>

              <Pattern id="blue" link="https://quizcards-docs-dev.s3.eu-west-1.amazonaws.com/site-documents/blue.png" size={{ x: 18, y: 18 }} />
              <Pattern id="green" link="https://quizcards-docs-dev.s3.eu-west-1.amazonaws.com/site-documents/green.png" size={{ x: 18, y: 18 }} />
              <Pattern id="orange" link="https://quizcards-docs-dev.s3.eu-west-1.amazonaws.com/site-documents/orange.png" size={{ x: 18, y: 18 }} />
              <Pattern id="purple" link="https://quizcards-docs-dev.s3.eu-west-1.amazonaws.com/site-documents/purple.png" size={{ x: 18, y: 18 }} />
              <Pattern id="red" link="https://quizcards-docs-dev.s3.eu-west-1.amazonaws.com/site-documents/red.png" size={{ x: 18, y: 18 }} />
              <Pattern id="yellow" link="https://quizcards-docs-dev.s3.eu-west-1.amazonaws.com/site-documents/yellow.png" size={{ x: 18, y: 18 }} />
            </Layout>
          </HexGrid>
        </MDBox>
      </MDBox>
      <MDBox
        sx={{ background: `#dff5fd` }}
      >
        <MDBox
          display='flex'
          flexDirection='column'
          justifyContent='space-between'
          width='100vw'

          maxWidth={1272}
          minWidth={isMobile ? 'fit-content' : 500}
          mx='auto'
        >
          <img style={{ marginLeft: 32, marginRight: 32 }} src={Logo} alt='quizedu' width={250} height={'100%'} />
          <Grid sx={{ my: 4 }} container spacing={4}>
            <Grid sx={{ height: 'fit-content' }} item xs={12} md={6}>
              <MDBox
                mx={isMobile ? 6 : { xs: 2, lg: 0 }}
                height='fit-content'
                display='flex'
                flexDirection='column'
                gap={2}
                width={{ xs: 320, sm: 400 }}
              >

                <Typography variant='body2'>Få mest ud fra QuizEdu: få seneste nyt</Typography>
                <MDBox
                  display='flex'
                  gap={5}
                >
                  <MDInput
                    label="Email"
                    placeholder='Skriv din email her'
                    style={{
                      backgroundColor: 'white',
                      width: 300,
                      borderRadius: 45
                    }}
                    sx={{
                      borderRadius: 45,
                      '& fieldset': {
                        borderRadius: 45,
                      },
                    }}
                    type='email'
                    value={emailBottom}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmailBottom(e.target.value)}
                  />
                  <MDButton
                    onClick={() => handleSubscrtibe(emailBottom)}
                    sx={{
                      borderRadius: 45,
                    }} color='error'>
                    Tilmeld
                  </MDButton>
                </MDBox>
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6}>
              <MDBox
                mx={isMobile ? 4 : 0}
                display={'flex'}
                justifyContent={isBigScreen ? 'end' : 'start'}
                alignItems='center'
                width={isBigScreen ? '100%' : '90vw'}
                height='fit-content'
                gap={1}
              >

                <MDBox>
                  <Typography mx={2} component='b' fontWeight={700}>Følg os på:</Typography>
                  <List>
                    <ListItemButton LinkComponent={Link} target='_blank' href='https://www.facebook.com/profile.php?id=100089081940552' sx={{ py: 0 }}>
                      <ListItemIcon sx={{ minWidth: '30px' }}><FacebookIcon /></ListItemIcon>
                      <ListItemText primary="Facebook" />
                    </ListItemButton>
                    <ListItemButton LinkComponent={Link} target='_blank' href='https://www.instagram.com/quizedu.dk' sx={{ py: 0 }}>
                      <ListItemIcon sx={{ minWidth: '30px' }}><InstagramIcon /></ListItemIcon>
                      <ListItemText primary="Instagram" />
                    </ListItemButton>
                    {/* <ListItemButton sx={{ py: 0 }}>
                        <ListItemIcon sx={{ minWidth: '30px' }}><TwitterIcon /></ListItemIcon>
                        <ListItemText primary="Twitter" />
                      </ListItemButton>
                      <ListItemButton LinkComponent={Link} target='_blank' href='https://www.linkedin.com/in/jesper-albinus-943620b3/' sx={{ py: 0 }}>
                        <ListItemIcon sx={{ minWidth: '30px' }}><LinkedInIcon /></ListItemIcon>
                        <ListItemText primary="LinkedIn" />
                      </ListItemButton> */}
                  </List>
                </MDBox>
              </MDBox>
            </Grid>
          </Grid>
          <hr />
          <Typography textAlign={'center'}>{(new Date()).getFullYear()} QuizEdu.dk. Alle rettigheder forbeholdes</Typography>
        </MDBox>
      </MDBox>

    </MDBox>
}
      </PageLayout >
  );
}

// Declaring default props for IllustrationLayout
IllustrationLayout.defaultProps = {
  header: "",
  title: "",
  description: "",
  illustration: "",
};

export default IllustrationLayout;
